import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ModalContainer from 'components/ModalContainer';

import FilledButton from 'components/Buttons/FilledButton';

import DateField from 'components/FormGroup/DateField';
import InputField from 'components/FormGroup/InputField';

import { percentAllocation } from 'utils/masks';

import * as S from '../EditAllocatedProfessional/styles';

function EditEmployeeToAllocate({
  includeEmployee,
  setAllEmployees,
  setEmployeesToAllocateData,
  selectedEmployee,
  isOpen,
  setIsOpen,
}) {
  const [initialAllocationDate, setInitialAllocationDate] = useState(
    new Date(),
  );
  const [finalAllocationDate, setFinalAllocationDate] = useState(new Date());
  const [allocationPercent, setAllocationPercent] = useState('');

  const {
    employeeInitialAllocation,
    employeeFinalAllocation,
    name,
    area,
    seniorLevel,
    percent,
    id: idFuncionario,
    idNivel,
    idFuncao,
  } = selectedEmployee;

  useEffect(() => {
    setInitialAllocationDate(
      new Date(employeeInitialAllocation.split('/').reverse().join(',')),
    );
    setFinalAllocationDate(
      new Date(employeeFinalAllocation.split('/').reverse().join(',')),
    );
    setAllocationPercent(percent);
  }, [employeeFinalAllocation, employeeInitialAllocation, percent]);

  const handleSubmit = () => {
    setAllEmployees(currentValues =>
      currentValues.filter(employee => employee.id !== idFuncionario),
    );

    setEmployeesToAllocateData(currentValues =>
      currentValues.filter(
        employee => employee.id_funcionario !== idFuncionario,
      ),
    );

    includeEmployee(
      name,
      area,
      seniorLevel,
      initialAllocationDate,
      finalAllocationDate,
      allocationPercent,
      idFuncionario,
      idFuncao,
      idNivel,
    );

    return setIsOpen(false);
  };

  return (
    <ModalContainer
      headText="Altere as informações de alocação"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <S.Item>
        <span>Nome do funcionário:</span>
        {name}
      </S.Item>
      <S.Item>
        <span>Cargo:</span>
        {area}
      </S.Item>
      <S.Item>
        <span>Nível de senioridade:</span>
        {seniorLevel}
      </S.Item>
      <S.Form>
        <DateField
          selectedValue={new Date(initialAllocationDate)}
          name="initialAllocationDate"
          placeholderText="Defina a data de início"
          onlyMonth={false}
          handleChange={e => setInitialAllocationDate(e)}
          labelText="Data de início da alocação"
        />

        <DateField
          selectedValue={new Date(finalAllocationDate)}
          name="finalAllocationDate"
          placeholderText="Defina a data de início"
          onlyMonth={false}
          handleChange={e => setFinalAllocationDate(e)}
          labelText="Data final da alocação"
        />

        <InputField
          labelText="Percentual de alocação"
          placeholderText="Redefina o percentual"
          name="allocationPercent"
          value={allocationPercent}
          width={50}
          handleChange={e =>
            setAllocationPercent(percentAllocation(e.target.value))
          }
        />
        <S.Buttons>
          <FilledButton
            buttonClass="cancel"
            text="Cancelar"
            handleClick={() => setIsOpen(false)}
          />
          <FilledButton
            buttonClass="confirm"
            text="Salvar alterações"
            handleClick={handleSubmit}
          />
        </S.Buttons>
      </S.Form>
    </ModalContainer>
  );
}

export default EditEmployeeToAllocate;

EditEmployeeToAllocate.propTypes = {
  includeEmployee: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  setAllEmployees: PropTypes.func.isRequired,
  setEmployeesToAllocateData: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};
